export default {
  list: {
    33: '620200000000',
    34: '620300000000',
    35: '620400000000',
    36: '620100000000',
    37: '620900000000',
    38: '232700000000',
    39: '231100000000',
    40: '230700000000',
    41: '230200000000',
    42: '230800000000',
    43: '230400000000',
    44: '231200000000',
    45: '230500000000',
    46: '230300000000',
    47: '230900000000',
    48: '230100000000',
    49: '231000000000',
    50: '230600000000',
    51: '220800000000',
    52: '220700000000',
    53: '220100000000',
    54: '222400000000',
    55: '220200000000',
    56: '220300000000',
    57: '220600000000',
    58: '210100000000',
    59: '210900000000',
    60: '211200000000',
    61: '150700000000',
    62: '152200000000',
    63: '152500000000',
    64: '150500000000',
    65: '632800000000',
    66: '630100000000',
    67: '632200000000',
    68: '632500000000',
    69: '630200000000',
    70: '632300000000',
    71: '632700000000',
    72: '632600000000',
    73: '513300000000',
    74: '510600000000',
    75: '510100000000',
    76: '511800000000',
    77: '511400000000',
    78: '510300000000',
    79: '511100000000',
    80: '513400000000',
    81: '510400000000',
    82: '653200000000',
    83: '653100000000',
    84: '653000000000',
    85: '652900000000',
    86: '652800000000',
    88: '652700000000',
    89: '650400000000',
    90: '654000000000',
    91: '650500000000',
    92: '650100000000',
    93: '652300000000',
    94: '654200000000',
    95: '650200000000',
    96: '654300000000',
    97: '540500000000',
    98: '540400000000',
    99: '540300000000',
    100: '540100000000',
    101: '540600000000',
    102: '540200000000',
    103: '542500000000',
    104: '530100000000',
    105: '532300000000',
    106: '530400000000',
    107: '532500000000',
    108: '530800000000',
    109: '532800000000',
    110: '530900000000',
    111: '532900000000',
    112: '530500000000',
    113: '533300000000',
    114: '530700000000',
    115: '533400000000',
    116: '533100000000',
    117: '620700000000',
    118: '620600000000',
    119: '441900000000',
    121: '460200000000',
    122: '420700000000',
    123: '150300000000',
    125: '460100000000',
    126: '340300000000',
    127: '340100000000',
    128: '341200000000',
    129: '340200000000',
    130: '340800000000',
    131: '110000000000',
    132: '500000000000',
    133: '350700000000',
    134: '350500000000',
    135: '621000000000',
    136: '621100000000',
    137: '440200000000',
    138: '440600000000',
    139: '440900000000',
    140: '440400000000',
    141: '441400000000',
    142: '450300000000',
    143: '451200000000',
    144: '451400000000',
    145: '450700000000',
    146: '520100000000',
    147: '520200000000',
    148: '130300000000',
    149: '130900000000',
    150: '130100000000',
    151: '130400000000',
    152: '410700000000',
    153: '410300000000',
    154: '411400000000',
    155: '411000000000',
    156: '420600000000',
    157: '421000000000',
    158: '430100000000',
    159: '430400000000',
    160: '321100000000',
    161: '320600000000',
    162: '320800000000',
    163: '360100000000',
    164: '360500000000',
    165: '220500000000',
    166: '210700000000',
    167: '210200000000',
    168: '150900000000',
    169: '150800000000',
    170: '610500000000',
    171: '610300000000',
    172: '370400000000',
    173: '371100000000',
    174: '370500000000',
    175: '371000000000',
    176: '140100000000',
    177: '532600000000',
    178: '330300000000',
    179: '330100000000',
    180: '330200000000',
    181: '640500000000',
    182: '622900000000',
    183: '220400000000',
    184: '210400000000',
    185: '513200000000',
    186: '511500000000',
    187: '442000000000',
    188: '341600000000',
    189: '341100000000',
    190: '341800000000',
    191: '131000000000',
    192: '350900000000',
    193: '350800000000',
    194: '350200000000',
    195: '350300000000',
    196: '620500000000',
    197: '441800000000',
    198: '440800000000',
    199: '441700000000',
    200: '441600000000',
    201: '445100000000',
    202: '451300000000',
    203: '451000000000',
    204: '450600000000',
    205: '520600000000',
    206: '520500000000',
    207: '130800000000',
    208: '131100000000',
    209: '410900000000',
    210: '410200000000',
    211: '410800000000',
    212: '411200000000',
    213: '410400000000',
    214: '411500000000',
    215: '410600000000',
    216: '420300000000',
    217: '420800000000',
    218: '420100000000',
    219: '430700000000',
    220: '430600000000',
    221: '431300000000',
    222: '430200000000',
    223: '320900000000',
    224: '320500000000',
    225: '360200000000',
    226: '361000000000',
    227: '210500000000',
    228: '211100000000',
    229: '150200000000',
    230: '152900000000',
    231: '610800000000',
    232: '610200000000',
    233: '610100000000',
    234: '371300000000',
    235: '371600000000',
    236: '370200000000',
    237: '140600000000',
    238: '140700000000',
    239: '511900000000',
    240: '510700000000',
    241: '511600000000',
    242: '512000000000',
    243: '330800000000',
    244: '331000000000',
    245: '330900000000',
    246: '640400000000',
    247: '623000000000',
    248: '511000000000',
    249: '530300000000',
    250: '340400000000',
    252: '341000000000',
    253: '340600000000',
    254: '350400000000',
    255: '350600000000',
    256: '621200000000',
    257: '440100000000',
    258: '445300000000',
    259: '445200000000',
    260: '451100000000',
    261: '450100000000',
    262: '520300000000',
    263: '520400000000',
    264: '130700000000',
    265: '130200000000',
    266: '130500000000',
    267: '410500000000',
    268: '410100000000',
    269: '411700000000',
    270: '420500000000',
    271: '421100000000',
    272: '430900000000',
    273: '430500000000',
    274: '433100000000',
    275: '431000000000',
    276: '321200000000',
    277: '321300000000',
    278: '360900000000',
    279: '360600000000',
    280: '211300000000',
    281: '210800000000',
    282: '210600000000',
    283: '150600000000',
    284: '610600000000',
    285: '611000000000',
    286: '370800000000',
    287: '370700000000',
    288: '370100000000',
    289: '310000000000',
    290: '140500000000',
    291: '511300000000',
    292: '331100000000',
    293: '330600000000',
    294: '330500000000',
    295: '450500000000',
    297: '150400000000',
    298: '341500000000',
    299: '341700000000',
    300: '350100000000',
    301: '441300000000',
    302: '440700000000',
    303: '440500000000',
    304: '450400000000',
    305: '450200000000',
    306: '522700000000',
    307: '130600000000',
    308: '411600000000',
    309: '411300000000',
    310: '420900000000',
    311: '420200000000',
    312: '430800000000',
    313: '430300000000',
    314: '431100000000',
    315: '320100000000',
    316: '320300000000',
    317: '320200000000',
    318: '360800000000',
    319: '211400000000',
    320: '210300000000',
    321: '150100000000',
    322: '640300000000',
    323: '610400000000',
    324: '610900000000',
    325: '370900000000',
    326: '370600000000',
    327: '141100000000',
    328: '140800000000',
    329: '510800000000',
    330: '510900000000',
    331: '510500000000',
    332: '120000000000',
    333: '330700000000',
    334: '330400000000',
    335: '640200000000',
    336: '530600000000',
    337: '340700000000',
    338: '441200000000',
    339: '441500000000',
    340: '440300000000',
    341: '450800000000',
    342: '522600000000',
    343: '522300000000',
    344: '411100000000',
    346: '321000000000',
    347: '320700000000',
    348: '320400000000',
    349: '360400000000',
    350: '360300000000',
    351: '211000000000',
    352: '610700000000',
    353: '371700000000',
    354: '370300000000',
    355: '140200000000',
    356: '140400000000',
    357: '140300000000',
    358: '340500000000',
    359: '620800000000',
    360: '640100000000',
    361: '450900000000',
    362: '421200000000',
    363: '431200000000',
    364: '361100000000',
    365: '360700000000',
    366: '371500000000',
    367: '140900000000',
    368: '141000000000',
    369: '511700000000',
    370: '341300000000',
    371: '421300000000',
    372: '371400000000',
    373: '422800000000',
    1215: '460400000000',
    2911: '8200000000000',
    2912: '8100000000000',
    9001: '7110341650825',
    9002: '7111135835616',
    9003: '7113286391187',
    9004: '7112735772392',
    9005: '7111363068475',
    9006: '7110872151750',
    9007: '7111448320652',
    9008: '7110683530667',
    9009: '7110496253116',
    9010: '7113431434442',
    9011: '7114088135938',
    9012: '7113368433646',
    9013: '7110941525844',
    9014: '7110805025214',
    9015: '7113659713107',
    9016: '7111810508871',
    9017: '7113392594310',
    9018: '7110628507899',
    9019: '7112732834600',
    9020: '7110006260735'
  }
};
